import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import styles from './PieChart.module.css';

const DEFAULT_COLORS = [
  '#0088FE', '#00C49F', '#FFBB28', '#FF8042',
  '#8884D8', '#82CA9D', '#FFC658', '#FF6B9D',
  '#C084FC', '#34D399', '#FBBF24', '#F87171'
]

function CustomPieChart({
  data = [],
  title = '',
  colors = DEFAULT_COLORS,
  width = "100%",
  height = 400,
  showLegend = true,
  showTooltip = true,
  innerRadius = 0,
  outerRadius = 80,
  dataKey = "value",
  nameKey = "name",
  labelLine = true,
  label = true,
}) {

  function renderLabel(entry) {
    const itemValue = entry[dataKey];
    const percent = ((itemValue / totalValue) * 100).toFixed(1);
    return `${percent}%`;
  }

  const totalValue = data.reduce((sum, d) => sum + d[dataKey], 0);

  const dataWithTotal = data.map(item => ({
    ...item,
    _total: totalValue
  }));

  function CustomTooltip({ active, payload }) {
    if (active && payload && payload.length) {
      const data = payload[0];
      const percent = ((data.value / data.payload._total) * 100).toFixed(1);
      return (
        <div className={styles.tooltip}>
          <p className={styles.tooltipName}>
            {data.name}
          </p>
          <p className={styles.tooltipValue}>
            Value: {data.value}
          </p>
          <p className={styles.tooltipPercentage}>
            Percentage: {percent}%
          </p>
        </div>
      );
    }
    return null;
  }

  if (!data || data.length === 0) {
    return (
      <div className={styles.chartContainer}>
        {title && <h3 className={styles.chartTitle}>{title}</h3>}
        <div className={styles.noData}>No data available</div>
      </div>
    );
  }

  return (
    <div className={styles.chartContainer}>
      {title && <h3 className={styles.chartTitle}>{title}</h3>}
      <div className={styles.chartWrapper}>
        <ResponsiveContainer width={width} height={height}>
          <PieChart>
            <Pie
              data={dataWithTotal}
              cx="50%"
              cy="50%"
              labelLine={labelLine}
              label={label ? renderLabel : false}
              outerRadius={outerRadius}
              innerRadius={innerRadius}
              fill="#8884d8"
              dataKey={dataKey}
              nameKey={nameKey}
            >
              {dataWithTotal.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>
            {showTooltip && <Tooltip content={<CustomTooltip />} />}
            {showLegend && (
              <Legend
                verticalAlign='bottom'
                height={36}
                iconType="circle"
              />
            )}
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default CustomPieChart;